import { render, staticRenderFns } from "./Overview.vue?vue&type=template&id=2bcf2dbb&"
import script from "./Overview.vue?vue&type=script&lang=js&"
export * from "./Overview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bcf2dbb')) {
      api.createRecord('2bcf2dbb', component.options)
    } else {
      api.reload('2bcf2dbb', component.options)
    }
    module.hot.accept("./Overview.vue?vue&type=template&id=2bcf2dbb&", function () {
      api.rerender('2bcf2dbb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/reservationAdministration/Overview.vue"
export default component.exports